import { createStore } from "vuex";

import advancedSearch from "@/store/AdvancedSearchComponents/advancedSearch";
import countriesSearch from "@/store/AdvancedSearchComponents/countriesSearch";
import domainsSearch from "@/store/AdvancedSearchComponents/domainsSearch";
import licencesSearch from "@/store/AdvancedSearchComponents/licencesSearch";
import objectTypes from "@/store/AdvancedSearchComponents/objectTypes";
import organisationSearch from "@/store/AdvancedSearchComponents/organisationSearch";
import recordTypes from "@/store/AdvancedSearchComponents/recordTypes";
import subjectSearch from "@/store/AdvancedSearchComponents/subjectSearch";
import taxonomiesSearch from "@/store/AdvancedSearchComponents/taxonomiesSearch";
import userDefinedTagsSearch from "@/store/AdvancedSearchComponents/userDefinedTagsSearch";
import saveSearch from "@/store/saveSearch";

import editor from "./editor";
import introspection from "./introspector.js";
import messages from "./messages";
import ontologyBrowser from "./ontologyBrowser";
import record from "./recordData.js";
import records from "./recordSearch.js";
import searchFilters from "./searchFilters.js";
import uiController from "./uiController";
import users from "./users.js";

export function createMyStore() {
  // Create a new store instance.
  return createStore({
    namespaced: true,
    modules: {
      searchFilters,
      records,
      record,
      introspection,
      users,
      uiController,
      editor,
      messages,
      ontologyBrowser: ontologyBrowser,
      advancedSearch,
      subjectSearch,
      recordTypes,
      organisationSearch,
      objectTypes,
      userDefinedTagsSearch,
      domainsSearch,
      taxonomiesSearch,
      licencesSearch,
      countriesSearch,
      saveSearch,
    },
  });
}

// export default store;
